import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
  ACCOUNT: {
    defaultMessage: 'Account',
    description: 'Label to filter by different options in the current account',
  },
  ALL: {
    defaultMessage: 'All',
    description: 'Label to show all',
  },
  CHANNEL: {
    defaultMessage: 'Channel',
    description: 'Label to filter by different channel options',
  },
  GLOBAL_ACTIVE_TEMPLATES: {
    defaultMessage: 'Global',
    description: 'Label for templates available to all customers',
  },
  GLOBAL_INACTIVE_TEMPLATES: {
    defaultMessage: 'Global (Drafts)',
    description:
      'Label for template available to all customers but that are not yet published (employee only)',
  },
  INDUSTRY: {
    defaultMessage: 'Industry',
    description: 'Label to filter by different industries',
  },
  OBJECTIVE: {
    defaultMessage: 'Objective',
    description: 'Label to filter by different advertising objective',
  },
  TYPE: {
    defaultMessage: 'Type',
    description: 'Label to filter by different template types',
  },
  YOUR_ACTIVE_TEMPLATES: {
    defaultMessage: '{groupName}',
    description:
      'Label for the templates available to the current selected account',
  },
  YOUR_INACTIVE_TEMPLATES: {
    defaultMessage: '{groupName} (Drafts)',
    description:
      'Label for the templates available to the current selected account but that are not published',
  },
});

export const TEMPLATE_FILTER_CATEGORY_DEFINITIONS = {
  ACCOUNT: {
    name: MESSAGES.ACCOUNT,

    YOUR_ACTIVE_TEMPLATES: {
      id: 'Your Active',
      name: MESSAGES.YOUR_ACTIVE_TEMPLATES,
    },
    YOUR_INACTIVE_TEMPLATES: {
      id: 'Your Inactive',
      name: MESSAGES.YOUR_INACTIVE_TEMPLATES,
    },
    GLOBAL_ACTIVE_TEMPLATES: {
      id: 'Global Active',
      name: MESSAGES.GLOBAL_ACTIVE_TEMPLATES,
    },
    GLOBAL_INACTIVE_TEMPLATES: {
      id: 'Global Inactive',
      name: MESSAGES.GLOBAL_INACTIVE_TEMPLATES,
    },
  },

  ALL: {
    id: 'All',
    name: MESSAGES.ALL,
  },
  CHANNEL: {
    name: MESSAGES.CHANNEL,
  },
  INDUSTRY: {
    name: MESSAGES.INDUSTRY,
  },
  OBJECTIVE: {
    name: MESSAGES.OBJECTIVE,
  },
  TYPE: {
    name: MESSAGES.TYPE,
  },
};

export const FILTER_TYPES = {
  TEMPLATE_ACCOUNT_TYPE: 'TEMPLATE_ACCOUNT_TYPE',
  TEMPLATE_TAG_CATEGORY_CUSTOM: 'TEMPLATE_TAG_CATEGORY_CUSTOM',
  TEMPLATE_TAG_CATEGORY_OBJECTIVE: 'TEMPLATE_TAG_CATEGORY_OBJECTIVE',
  TEMPLATE_TAG_CATEGORY_TYPE: 'TEMPLATE_TAG_CATEGORY_TYPE',
  TEMPLATE_TAG_CATEGORY_STYLE: 'TEMPLATE_TAG_CATEGORY_STYLE',
  TEMPLATE_TAG_CATEGORY_FEATURE: 'TEMPLATE_TAG_CATEGORY_FEATURE',
};

export const FILTER_LABELS = defineMessages({
  [FILTER_TYPES.TEMPLATE_ACCOUNT_TYPE]: {
    defaultMessage: 'Account',
    description: 'Filter label for account',
  },
  [FILTER_TYPES.TEMPLATE_TAG_CATEGORY_CUSTOM]: {
    defaultMessage: 'Custom',
    description: 'Filter label for Custom',
  },
  [FILTER_TYPES.TEMPLATE_TAG_CATEGORY_TYPE]: {
    defaultMessage: 'Type',
    description: 'Filter label for Type',
  },
  [FILTER_TYPES.TEMPLATE_TAG_CATEGORY_STYLE]: {
    defaultMessage: 'Style',
    description: 'Filter label for Style',
  },
  [FILTER_TYPES.TEMPLATE_TAG_CATEGORY_OBJECTIVE]: {
    defaultMessage: 'Objective',
    description: 'Filter label for Objective',
  },
  [FILTER_TYPES.TEMPLATE_TAG_CATEGORY_FEATURE]: {
    defaultMessage: 'Feature',
    description: 'Filter label for Feature',
  },
});

export const VALID_FILTER_TYPES = new Set(Object.keys(FILTER_TYPES));
